/**
 * The function only throws error when called.
 * It's purpose is to prevent coder from forgetting some branch in the case statement.
 * It is usually used in combination with switch block and enum where developer wants to cover all enum cases
 *
 * @example
 * enum Numbers {
 *   One
 *   Two
 * }
 * ...
 * function getLabel(num: Numbers): string {
 *   switch(num) {
 *     case Numbers.One:
 *       return "One";
 *     case Numbers.Two:
 *       return "Two";
 *     default:
 *       unreachable(num);
 *   }
 * }
 *
 * @param value: never
 */

export function unreachable(value: never): never {
  throw new Error(`Switch value shouldn't be reached ${value}`);
}
